
















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';

import ProductApplicationsModal from '../modals/ProductApplicationsModal.vue';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'product-applications',
    components: {
        ProductApplicationsModal,
        Spinner,
    },
    computed: {
        ...mapState('productApplications', ['allProductApplications', 'allProductApplicationsLoading']),
        ...mapState('auth', ['currentUser']),
    },
})
export default class ProductApplications extends Vue {
    public allProductApplications!: any;
    public allProductApplicationsLoading!: any;
    public application_search: any = '';
    public ordersPerPage!: any;
    public ordersPage!: any;
    // public ordersTotal!: any;
    private activeOrderLoaded: boolean = false;
    private activeFilters: boolean = false;

    allProductApplicationsHeaders = [
        { thClass: 'th', key: 'id', label: 'ID' },
        { thClass: 'th', key: 'name', label: 'Nombre' },
        { thClass: 'th', key: 'edit', label: '' },
        { thClass: 'th', key: 'delete', label: '' },
    ];

    private currentUser!: any;

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    get allProductApplicationsCollection() {
        return this.allProductApplications.filter((cat) => {
            return (
                cat.name.includes(this.application_search) ||
                cat.name.toLowerCase().includes(this.application_search) ||
                cat.name.toUpperCase().includes(this.application_search)
            );
        });
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'product-applications',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'desc' : 'asc',
            },
        });
    }

    clearFilters() {
        this.$router.push({
            path: 'orders',
            query: {},
        });
    }

    onEditOrder(id: number) {
        this.$store.dispatch('orders/getOne', { id });
        this.activeOrderLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('order-detail-modal');
        }, 400);
    }

    @Watch('$route')
    getAllProductApplications() {
        if (this.$route.query.search) {
            this.$store.dispatch('productApplications/getAll', {
                search: <string>this.$route.query.search,
            });
        } else {
            this.$store.dispatch('productApplications/getAll');
        }
    }

    onOpenProductApplicationModal(id: string | null = null) {
        this.$store.dispatch('productApplications/getOne', id);
        setTimeout(() => {
            this.$bvModal.show('product-applications-modal');
        }, 400);
    }

    onDeleteProductApplicationModal(id: string) {
        this.$store.dispatch('productApplications/deleteOne', { id, vm: this });
        setTimeout(() => {
            this.$store.dispatch('productApplications/getAll');
        });
    }

    mounted() {
        this.getAllProductApplications();
        this.ordersPage = 1;
    }
}
